import { render } from "./TemplateDemandBooking2.vue?vue&type=template&id=ba9b1a5e"
import script from "./TemplateDemandBooking2.vue?vue&type=script&lang=js"
export * from "./TemplateDemandBooking2.vue?vue&type=script&lang=js"
script.render = render

export default script